export function getScheduleStatus(schedule, currentMileage) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  let dateStatus  = null
  let milesStatus = null
  let daysUntil   = null
  let milesUntil  = null

  if (schedule.next_due_date) {
    const due = new Date(schedule.next_due_date)
    daysUntil = Math.round((due - today) / (1000 * 60 * 60 * 24))
    if (daysUntil < 0)       dateStatus = 'overdue'
    else if (daysUntil <= 30) dateStatus = 'due-soon'
    else                      dateStatus = 'ok'
  }

  if (schedule.next_due_mileage != null && currentMileage != null) {
    milesUntil = schedule.next_due_mileage - currentMileage
    if (milesUntil <= 0)       milesStatus = 'overdue'
    else if (milesUntil <= 1000) milesStatus = 'due-soon'
    else                         milesStatus = 'ok'
  }

  let status = 'unknown'
  if (dateStatus === 'overdue'   || milesStatus === 'overdue')   status = 'overdue'
  else if (dateStatus === 'due-soon' || milesStatus === 'due-soon') status = 'due-soon'
  else if (dateStatus === 'ok'   || milesStatus === 'ok')         status = 'ok'

  return { status, daysUntil, milesUntil }
}

export const STATUS_STYLES = {
  overdue:    { badge: 'bg-red-500/15 text-red-400 border border-red-500/20',     dot: 'bg-red-400',    label: 'Overdue'    },
  'due-soon': { badge: 'bg-amber-500/15 text-amber-400 border border-amber-500/20', dot: 'bg-amber-400',  label: 'Due soon'   },
  ok:         { badge: 'bg-green-500/15 text-green-400 border border-green-500/20', dot: 'bg-green-400',  label: 'Up to date' },
  unknown:    { badge: 'bg-[var(--bg-overlay)] text-[var(--text-muted)] border border-[var(--border)]', dot: 'bg-[var(--text-muted)]', label: 'No data' },
}
